import type { CustomerObjectType } from '../../../store/types/user.d'

export const getUserFullName = (
  humanName?: CustomerObjectType['humanName'],
) => {
  if (humanName) {
    if (humanName.firstName && humanName.lastName) {
      return `${humanName.firstName} ${humanName.lastName}`
    }

    if (humanName.fullName) {
      return humanName.fullName
    }

    if (humanName.firstName) {
      return humanName.firstName
    }

    if (humanName.lastName) {
      return humanName.lastName
    }
  }

  return 'Customer'
}
